import { object, string, ref } from '~utils/validation';

export default object({
  password: string()
    .atLeastOneCharacter('Senha deve ter pelo menos uma letra')
    .atLeastOneNumber('Senha deve ter pelo menos um número')
    .atLeastOneSimbol('Senha deve ter pelo menos um símbolo')
    .min(8)
    .required(),
  confirmation: string()
    .oneOf([ref('password'), null], 'Senha não confere')
    .required(),
});
